import { cx } from 'class-variance-authority';
import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';

type CommandItemProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Item> & {
  size?: 'compact' | 'default';
  disabled?: boolean;
  keywords?: string[];
};

const CommandItem = forwardRef<HTMLDivElement, CommandItemProps>(
  ({ className, disabled, keywords, size = 'default', ...props }, ref) => (
    <CommandPrimitive.Item
      ref={ref}
      keywords={keywords}
      className={cx(
        'flex justify-between cursor-pointer rounded',
        'data-[selected=true]:bg-(--dropdown-hover-bg) data-[selected=false]:hover:bg-(--dropdown-hover-bg)',
        {
          'text-quaternary bg-secondary pointer-events-none': disabled,
        },
        {
          'py-1.5 px-3': size === 'default',
          'py-1.5 px-2': size === 'compact',
        },
        className,
      )}
      data-disabled={disabled}
      {...props}
    />
  ),
);

export default CommandItem;
